// src/content/termsContent.ts
// 利用規約の本文(中日バイリンガル)。全文ページ(TermsOfUsePage)とLPのモーダルで共用する単一データソース。
export type LJ = { ja: string; zh: string };
export type LJList = { ja: string[]; zh: string[] };

export const termsTitle: LJ = { ja: '利用規約', zh: '使用条款' };

export const termsIntro: LJ = {
  ja: '本利用規約（以下「本規約」）は、SMHC株式会社（以下「当社」）が提供するオンライン診療サービス「Melodis Clinic」（以下「本サービス」）の利用条件を定めるものです。利用者（以下「ユーザー」）は、本規約に同意のうえ本サービスを利用するものとします。',
  zh: '本使用条款（以下简称“本条款”）规定了 SMHC株式会社（以下简称“本公司”）所提供的在线诊疗服务“Melodis Clinic”（以下简称“本服务”）的使用条件。用户（以下简称“用户”）须在同意本条款的前提下使用本服务。',
};

export const termsEnacted: LJ = { ja: '制定日：2026年6月', zh: '制定日期：2026年6月' };

export const termsArticles: { title: LJ; body: LJList }[] = [
  {
    title: { ja: '第1条（適用）', zh: '第1条（适用）' },
    body: {
      ja: [
        '本規約は、本サービスの利用に関する当社とユーザーとの間の一切の関係に適用されます。',
        '当社が本サービス上で別途定める個別規定・ガイドライン等は、本規約の一部を構成します。本規約と個別規定が矛盾する場合は、個別規定が優先します。',
      ],
      zh: [
        '本条款适用于本公司与用户之间有关本服务使用的一切关系。',
        '本公司在本服务中另行规定的个别条款、指南等构成本条款的一部分。本条款与个别条款不一致时，以个别条款优先。',
      ],
    },
  },
  {
    title: { ja: '第2条（定義）', zh: '第2条（定义）' },
    body: {
      ja: [
        '「本サービス」とは、当社が提供するオンライン診療予約・問診・ビデオ診療・処方・医薬品配送等の一連のサービスをいいます。',
        '「登録医療機関・医師」とは、本サービスを通じて診療を提供する医療機関および医師をいいます。診療行為の主体は登録医療機関・医師であり、当社はその予約・連絡・決済等を支援するプラットフォームを提供します。',
        '「ユーザー」とは、本規約に同意し本サービスを利用する個人をいいます。',
      ],
      zh: [
        '“本服务”指本公司提供的在线诊疗预约、问诊、视频诊疗、处方、药品配送等一系列服务。',
        '“登记医疗机构・医生”指通过本服务提供诊疗的医疗机构及医生。诊疗行为的主体为登记医疗机构・医生，本公司提供支持其预约、联络、结算等的平台。',
        '“用户”指同意本条款并使用本服务的个人。',
      ],
    },
  },
  {
    title: { ja: '第3条（会員登録）', zh: '第3条（会员注册）' },
    body: {
      ja: [
        'ユーザーは、当社所定の方法により正確かつ最新の情報を登録するものとします。',
        '未成年者が本サービスを利用する場合は、親権者等法定代理人の同意を得るものとします。',
        '登録情報に虚偽・誤りがあった場合、または以下の各号に該当すると当社が判断した場合、当社は登録を拒否し、または利用を停止できます。',
        '（1）過去に本規約違反等で利用停止措置を受けたことがある場合',
        '（2）反社会的勢力等に該当し、または関与していると認められる場合',
        '（3）その他、当社が登録を適当でないと判断した場合',
      ],
      zh: [
        '用户须以本公司规定的方式登记准确且最新的信息。',
        '未成年人使用本服务时，须取得监护人等法定代理人的同意。',
        '登记信息存在虚假或错误，或本公司认定符合下列各项情形时，本公司可拒绝注册或停止其使用。',
        '（1）过去曾因违反本条款等被采取停止使用措施；',
        '（2）被认定属于或涉及反社会势力等；',
        '（3）其他本公司认为不适宜注册的情形。',
      ],
    },
  },
  {
    title: { ja: '第4条（ユーザーID・パスワードの管理）', zh: '第4条（用户ID与密码管理）' },
    body: {
      ja: [
        'ユーザーは、自己の責任においてID・パスワード等の認証情報を適切に管理するものとし、第三者に利用させ、または貸与・譲渡してはなりません。',
        '認証情報の管理不十分・第三者の使用等によって生じた損害について、当社は責任を負いません。',
      ],
      zh: [
        '用户须自行妥善管理ID、密码等认证信息，不得让第三方使用，亦不得出借或转让。',
        '因认证信息管理不善或被第三方使用等所产生的损害，本公司不承担责任。',
      ],
    },
  },
  {
    title: { ja: '第5条（オンライン診療）', zh: '第5条（在线诊疗）' },
    body: {
      ja: [
        '本サービスにおける診療は、情報通信機器を用いたオンライン診療として実施されます。診療の可否・内容・処方の有無は、登録医師の医学的判断によります。',
        '医師は、診療の結果、オンライン診療が適切でないと判断した場合、対面診療・他医療機関の受診を勧奨し、または処方を行わないことがあります。',
        'オンライン診療は対面診療を完全に代替するものではありません。緊急性が高い症状・急変時は、ただちに医療機関の受診または救急要請を行ってください。',
        '本サービスは、疾病の治癒・効果・特定の結果を保証するものではありません。',
        '診療の品質・安全確保および記録の目的で、ビデオ診療の録音・録画を行う場合があります。ユーザーはこれに同意するものとします。',
        '本人確認のため、初診時等に顔写真付き身分証明書の提示を求める場合があります。',
        'ユーザーは、プライバシーが保たれた環境で受診し、診療中の録音・録画・第三者への共有を行わないものとします。',
        '医薬品の使用後に副作用・体調異常を感じた場合、ユーザーはただちに医療機関を受診するものとします。',
      ],
      zh: [
        '本服务中的诊疗以使用信息通信设备的在线诊疗方式实施。是否诊疗、诊疗内容及是否处方，均由登记医生的医学判断决定。',
        '医生在诊疗结果上认定在线诊疗不适宜时，可建议面诊或就诊其他医疗机构，或不予处方。',
        '在线诊疗不能完全替代面诊。出现紧急性高的症状或病情急变时，请立即就诊医疗机构或呼叫急救。',
        '本服务不保证疾病治愈、疗效或特定结果。',
        '出于确保诊疗质量与安全及记录之目的，可能对视频诊疗进行录音・录像，用户对此表示同意。',
        '为核验本人身份，初诊时等可能要求出示带照片的身份证件。',
        '用户须在能够保护隐私的环境中就诊，且不得对诊疗过程进行录音・录像或向第三方分享。',
        '使用药品后如感到副作用或身体异常，用户须立即就诊医疗机构。',
      ],
    },
  },
  {
    title: { ja: '第6条（処方・医薬品の取扱い）', zh: '第6条（处方与药品的处理）' },
    body: {
      ja: [
        '処方の有無・内容は医師の判断によるものとし、ユーザーの希望どおりの処方を保証するものではありません。',
        '処方された医薬品は、医師の指示・用法用量を遵守して使用するものとします。自己判断による増減・中止は行わないでください。',
        '処方医薬品の第三者への譲渡・転売・再配布は固く禁止します。',
      ],
      zh: [
        '是否处方及处方内容由医生判断，不保证按用户希望进行处方。',
        '所处方的药品须遵守医生指示及用法用量使用，请勿自行增减或停用。',
        '严禁将处方药品转让、转卖或再分发给第三方。',
      ],
    },
  },
  {
    title: { ja: '第7条（利用料金および決済）', zh: '第7条（使用费用与结算）' },
    body: {
      ja: [
        'ユーザーは、診察料・医薬品代・配送料等、本サービス上に表示される料金を当社所定の方法で支払うものとします。',
        '決済手数料・通信費等、利用に伴う費用はユーザーの負担とします。',
        '当社は、料金債権を第三者（決済代行業者等）に委託・譲渡することがあります。',
      ],
      zh: [
        '用户须就诊费、药品费、配送费等本服务中显示的费用，以本公司规定的方式支付。',
        '结算手续费、通信费等因使用而产生的费用由用户负担。',
        '本公司可将费用债权委托或转让给第三方（结算代理机构等）。',
      ],
    },
  },
  {
    title: { ja: '第8条（定期配送）', zh: '第8条（定期配送）' },
    body: {
      ja: [
        '定期配送（継続処方・リフィル）を申し込んだ場合、所定の周期で診療・決済・配送が継続されます。',
        '定期配送の変更・停止は、次回決済の所定日前までに当社所定の方法で手続を行うものとします。所定日を過ぎた手続は次回以降に反映されます。',
        '医師が継続を適切でないと判断した場合、定期配送を中止することがあります。',
      ],
      zh: [
        '申请定期配送（持续处方・续方）后，将按规定周期持续进行诊疗、结算与配送。',
        '定期配送的变更或停止，须在下次结算的规定日之前以本公司规定的方式办理。超过规定日办理的，将于下一次以后生效。',
        '医生认定不宜继续时，可中止定期配送。',
      ],
    },
  },
  {
    title: { ja: '第9条（キャンセル・返金）', zh: '第9条（取消与退款）' },
    body: {
      ja: [
        '予約のキャンセル・変更は、本サービス上に定める方法・期限に従うものとします。',
        'サービスの性質上、診療・処方確定後および医薬品発送後の返品・交換・返金はできません。',
        '返金に関する詳細は「特定商取引法に基づく表示」の定めによります。',
      ],
      zh: [
        '预约的取消与变更，须遵循本服务规定的方式与期限。',
        '鉴于服务性质，诊疗・处方确定后及药品发货后，不可退货、换货或退款。',
        '有关退款的详情，依《基于特定商取引法的标示》之规定。',
      ],
    },
  },
  {
    title: { ja: '第10条（禁止事項）', zh: '第10条（禁止事项）' },
    body: {
      ja: [
        'ユーザーは、本サービスの利用にあたり、以下の行為を行ってはなりません。',
        '（1）法令・公序良俗に違反する行為',
        '（2）虚偽の情報の登録・申告、なりすまし',
        '（3）処方医薬品の転売・譲渡・不正取得',
        '（4）診療の録音・録画データ等の無断公開・第三者提供',
        '（5）当社・医療機関・医師・他のユーザー・第三者の権利を侵害し、または名誉・信用を毀損する行為',
        '（6）本サービスの運営を妨害し、またはネットワーク・システムに不正にアクセスする行為',
        '（7）その他、当社が不適切と判断する行為',
      ],
      zh: [
        '用户在使用本服务时，不得进行以下行为：',
        '（1）违反法律法规或公序良俗的行为；',
        '（2）登记・申报虚假信息、冒充他人；',
        '（3）转卖、转让或不正当获取处方药品；',
        '（4）擅自公开诊疗录音・录像数据等或提供给第三方；',
        '（5）侵害本公司、医疗机构、医生、其他用户或第三方权利，或损害其名誉・信用的行为；',
        '（6）妨碍本服务运营，或非法访问网络・系统的行为；',
        '（7）其他本公司认定为不适当的行为。',
      ],
    },
  },
  {
    title: { ja: '第11条（個人情報・健康情報の取扱い）', zh: '第11条（个人信息与健康信息的处理）' },
    body: {
      ja: [
        '当社は、ユーザーの個人情報・健康情報を「個人情報保護方針」に従い適切に取り扱います。',
        '当社は、診療の提供に必要な範囲で、登録医療機関・医師に対しユーザーの診療関連情報を共有します。ユーザーはこれに同意するものとします。',
      ],
      zh: [
        '本公司依《个人信息保护方针》妥善处理用户的个人信息与健康信息。',
        '本公司在提供诊疗所必需的范围内，向登记医疗机构・医生共享用户的诊疗相关信息，用户对此表示同意。',
      ],
    },
  },
  {
    title: { ja: '第12条（免責事項）', zh: '第12条（免责事项）' },
    body: {
      ja: [
        '診療内容および処方に関する医学的責任は、診療を行った登録医療機関・医師に帰属します。',
        '当社は、通信環境・端末・システムの不具合、データの消失、本サービスの中断等によりユーザーに生じた損害について、当社の故意または重過失による場合を除き、責任を負いません。',
        'ユーザーが本規約・医師の指示に違反したことにより生じた損害について、当社は責任を負いません。',
      ],
      zh: [
        '诊疗内容及处方相关的医学责任，归属于实施诊疗的登记医疗机构・医生。',
        '因通信环境、终端、系统故障、数据丢失、本服务中断等给用户造成的损害，除本公司故意或重大过失外，本公司不承担责任。',
        '因用户违反本条款或医生指示而产生的损害，本公司不承担责任。',
      ],
    },
  },
  {
    title: { ja: '第13条（サービスの変更・中断・終了）', zh: '第13条（服务的变更・中断・终止）' },
    body: {
      ja: [
        '当社は、ユーザーへの事前告知なく本サービスの内容を変更し、または提供を中断・終了することがあります。',
        'これによりユーザーに生じた損害について、当社は故意または重過失による場合を除き責任を負いません。',
      ],
      zh: [
        '本公司可不经事先通知变更本服务内容，或中断・终止其提供。',
        '由此给用户造成的损害，除本公司故意或重大过失外，本公司不承担责任。',
      ],
    },
  },
  {
    title: { ja: '第14条（利用停止・退会）', zh: '第14条（停止使用・退会）' },
    body: {
      ja: [
        'ユーザーが本規約に違反した場合、当社は事前の通知なく利用停止・登録抹消等の措置をとることができます。',
        'ユーザーは、当社所定の方法により退会できます。退会後も、決済が完了した注文のキャンセル・返金はできません。',
        '退会後も、当社は法令・診療記録の保存義務に従い必要な情報を所定期間保管します。',
      ],
      zh: [
        '用户违反本条款时，本公司可不经事先通知采取停止使用、注销注册等措施。',
        '用户可通过本公司规定的方式退会。退会后，已完成结算的订单亦不可取消或退款。',
        '退会后，本公司仍依法律及诊疗记录保存义务，在规定期间内保管必要信息。',
      ],
    },
  },
  {
    title: { ja: '第15条（本規約の変更）', zh: '第15条（本条款的变更）' },
    body: {
      ja: [
        '当社は、必要と判断した場合、本規約を変更することができます。',
        '変更後の本規約は、本サービス上に表示した時点から効力を生じ、以後の利用には変更後の規約が適用されます。',
      ],
      zh: [
        '本公司认为必要时，可变更本条款。',
        '变更后的本条款自在本服务中公示之时起生效，此后的使用适用变更后的条款。',
      ],
    },
  },
  {
    title: { ja: '第16条（反社会的勢力の排除）', zh: '第16条（排除反社会势力）' },
    body: {
      ja: [
        'ユーザーは、自らが暴力団等の反社会的勢力に該当せず、将来にわたっても該当しないことを表明・保証するものとします。',
        'これに違反した場合、当社は何らの催告なく利用停止・登録抹消等の措置をとることができます。',
      ],
      zh: [
        '用户声明并保证，自身不属于黑社会等反社会势力，且今后亦不属于。',
        '违反此项时，本公司可不经任何催告采取停止使用、注销注册等措施。',
      ],
    },
  },
  {
    title: { ja: '第17条（準拠法・管轄裁判所）', zh: '第17条（准据法与管辖法院）' },
    body: {
      ja: [
        '本規約の準拠法は日本法とします。',
        '本サービスまたは本規約に関して当社とユーザーとの間に紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。',
      ],
      zh: [
        '本条款的准据法为日本法。',
        '就本服务或本条款，本公司与用户之间发生纠纷时，以东京地方法院为第一审专属协议管辖法院。',
      ],
    },
  },
];
